import moment from "moment"

// dataURL to blob
export const dataURLtoBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = window.atob(b64Data)
  //   const byteCharacters = Buffer.from(b64Data, "base64")
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

// blob to base64
export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

// Substract days starts from today
export function substractDays(number = 30) {
  const currentDate = moment().subtract(number, "d").format("YYYY-MM-DD")
  return currentDate
}

// Calculate difference entre two number
export function diffPrice(numberA, numberB) {
  return numberA - numberB
}

export function getStateMaylrezCode(status) {
  console.log("status ===>", status.replace(/\s/g, ""))
  switch (status.replace(/\s/g, "")) {
    case "Ariana":
      return "ARI"
    case "Béja":
      return "BJA"
    case "Ben Arous":
      return "BEN"
    case "Bizerte":
      return "BIZ"
    case "Gabès":
      return "GBS"
    case "Gafsa":
      return "GFS"
    case "Jendouba":
      return "JDB"
    case "Kairouan":
      return "KRN"
    case "Kasserine":
      return "KSR"
    case "Kébili":
      return "KBL"
    case "LeKef":
      return "KEF"
    case "Mahdia":
      return "MHD"
    case "LaManouba":
      return "MAN"
    case "Médenine":
      return "MDN"
    case "Monastir":
      return "MNS"
    case "Nabeul":
      return "NAB"
    case "Sfax":
      return "SFX"
    case "Sousse":
      return "SOS"
    case "Siliana":
      return "SLI"
    case "SidiBouzid":
      return "SBZ"
    case "Tataouine":
      return "TAN"
    case "Tozeur":
      return "TZR"
    case "Tunis":
      return "TUN"
    case "Zaghouan":
      return "ZAG"
    default:
      return ""
  }
}
